<!-- 近一年发生巨额赎回 -->
<template>
  <div v-if="!$isEmpty(warnList) && !isDelListedFund" class="box" @click="$goFundApp">
    <fund-announce v-for="(item, index) in warnList" :key="index"
      :content="item.content"
      :hotKeys="item.hotKey"
    />
  </div>
</template>

<script>
import FundAnnounce from '../../../components/common/FundAnnounce.vue';

export default {
  name: 'fund-warn-tips',

  components: { FundAnnounce },

  props: {
    basicInfo: {
      type: Object,
      default: () => ({}),
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    isDelListedFund() {
      return this.basicInfo?.isDelListedFund || false;
    },
    warnList() {
      return this.detailInfo?.warnList || [];
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 24px;
}
</style>
